module.exports = __webpack_public_path__ + "assets/img/5_1351_big.4451ccf0.jpg";